import type { ReactElement } from 'react';
import { useServices, useT } from '../../../app/di';
import { useResource } from '../../../shared/hooks';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Button } from '../../../ui-kit/Button/Button';
import { Loading } from '../../../ui-kit/Loading/Loading';
import { PageHeader } from '../../../ui-kit/PageHeader/PageHeader';
import { PlatformBlogs } from './PlatformBlogs/PlatformBlogs';

// ADM-UC-2, ADM-RULE-1, ADM-RULE-2
export function AdminBlogsPage(): ReactElement {
  const { api } = useServices();
  const { t, te } = useT();
  const blogs = useResource(() => api.admin.blogs(), [api]);

  return (
    <div className="u-stack-lg">
      <PageHeader
        title={t('admin.blogs.title')}
        subtitle={t('admin.blogs.subtitle')}
        actions={
          <Button icon="search" loading={blogs.loading} onClick={() => void blogs.reload()}>
            {t('admin.overview.refresh')}
          </Button>
        }
      />
      {blogs.loading && !blogs.data ? (
        <Loading label={t('common.loading')} />
      ) : blogs.error || !blogs.data ? (
        <Alert tone="danger" title={t('common.loadFailed')}>
          {te(blogs.error)}
        </Alert>
      ) : (
        <PlatformBlogs blogs={blogs.data.blogs} month={blogs.data.month} />
      )}
    </div>
  );
}
